import { takeLatest, call, put } from 'redux-saga/effects';
import INSTITUTION_TYPES from './types';
import institutionActions from './actions';
import { sagaWrapper } from 'src/helpers';
import Service from 'src/service';
import { type IResponseMetadata, type IResponse } from 'src/models';
import notificationActions from '../Notifications/actions';

const Institution = new Service('institutions');

function* getAll({ payload }: any) {
	const response: IResponseMetadata = yield call(Institution.getAll, payload);
	yield put(institutionActions.setAll(response.data, response.metadata));
}

function* getOne({ payload }: any) {
	const response: IResponse = yield call(Institution.getOne, payload.id);
	yield put(institutionActions.setOne(response.data));
}

function* create({ payload }: any) {
	yield call(Institution.create, payload.institution);
	yield put(notificationActions.add('success', 'Institución creada'));
	yield put(institutionActions.getAll());
}

function* update({ payload }: any) {
	yield call(Institution.update, payload.institution);
	yield put(notificationActions.add('success', 'Institución actualizada'));
	yield put(institutionActions.getAll());
}

function* remove({ payload }: any) {
	yield call(Institution.delete, payload.id);
	yield put(notificationActions.add('success', 'Institución Eliminada'));
	yield put(institutionActions.getAll());
}

function* assignCourses({ payload }: any) {
	const { institutionId, institutionCourses } = payload;
	yield call(
		Institution.createPath,
		`courses/${institutionId}`,
		institutionCourses,
	);
	yield put(notificationActions.add('success', 'Cursos actualizados'));
}

export default function* index() {
	yield takeLatest(
		INSTITUTION_TYPES.GET_ALL,
		sagaWrapper(getAll, institutionActions.setAll([])),
	);
	yield takeLatest(
		INSTITUTION_TYPES.GET_ONE,
		sagaWrapper(getOne, institutionActions.setOne({})),
	);
	yield takeLatest(INSTITUTION_TYPES.CREATE, sagaWrapper(create));
	yield takeLatest(INSTITUTION_TYPES.UPDATE, sagaWrapper(update));
	yield takeLatest(INSTITUTION_TYPES.REMOVE, sagaWrapper(remove));
	yield takeLatest(
		INSTITUTION_TYPES.ASSIGN_COURSES,
		sagaWrapper(assignCourses),
	);
}
